import type { RsvpGuest } from "../types/rsvp";

export type RsvpTableViewMode = "rsvp" | "guest_list";
export type RsvpSortKey = "party_size" | "amount";
export type RsvpSortDir = "asc" | "desc";

export function sortRsvpGuestsForTable(
  rows: RsvpGuest[],
  tableView: RsvpTableViewMode,
  sortKey: RsvpSortKey,
  sortDir: RsvpSortDir,
): RsvpGuest[] {
  const sorted = [...rows];
  sorted.sort((a, b) => {
    if (tableView === "guest_list") {
      const aApproved = a.approved === true ? 1 : 0;
      const bApproved = b.approved === true ? 1 : 0;
      if (aApproved !== bApproved) return aApproved - bApproved;
    }
    const cmp =
      sortKey === "party_size" ? a.party_size - b.party_size : (a.amount ?? 0) - (b.amount ?? 0);
    return sortDir === "asc" ? cmp : -cmp;
  });
  return sorted;
}
